import { render, staticRenderFns } from "./AccountRealTimeDeals.vue?vue&type=template&id=646327c0&scoped=true&"
import script from "./AccountRealTimeDeals.vue?vue&type=script&lang=js&"
export * from "./AccountRealTimeDeals.vue?vue&type=script&lang=js&"
import style0 from "./AccountRealTimeDeals.vue?vue&type=style&index=0&id=646327c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646327c0",
  null
  
)

export default component.exports